export const CONFIRMED = 'confirmed';
export const UNCONFIRMED = 'unconfirmed';
export const REJECTED = 'rejected';
export const CANCELED = 'canceled';
